import { apiUserLanguages } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'users/languages';

const config = [
  { actionType: 'getAll', apiPath: apiUserLanguages, method: get, actionParams: { limit: 0 } },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiUserLanguages}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
